import React from "react";
import { COLORS, setStoredColor } from "@/hooks/usePillowOptions";

/**
 * Mini section showcasing the 5 available pillow colors as luxury cards.
 * Click a color → store it as selected and scroll to ShopZone.
 */
export default function ColorShowcase() {
  const handlePick = (key) => {
    setStoredColor(key);
    document.getElementById("shop")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      data-testid="color-showcase"
      className="aurora-wrap py-20 md:py-28"
    >
      <div className="container-x">
        <div className="text-center max-w-3xl mx-auto">
          <span className="section-pill">🎨 5 luxury editions</span>
          <h2 className="mt-5 text-[34px] sm:text-[44px] md:text-[56px] leading-[1.05] font-black tracking-[-0.02em] text-[#0e0e10]">
            Pick your color.
            <br />
            <span className="text-[#8a8a8a]">Sleep in your style.</span>
          </h2>
          <p className="mt-5 text-[15px] md:text-[16px] text-[#3a3a40] max-w-xl mx-auto leading-relaxed">
            Every edition is hand-stitched with identical 800+ fill power Hungarian goose down. The only choice you make is which one matches your bedroom.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {COLORS.map((c) => (
            <button
              key={c.key}
              type="button"
              onClick={() => handlePick(c.key)}
              data-testid={`color-showcase-card-${c.key.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative bg-white rounded-3xl overflow-hidden border border-black/5 shadow-sm text-left transition hover:shadow-2xl hover:-translate-y-1"
            >
              <div className="aspect-[4/5] overflow-hidden bg-[#0e0e10]">
                <img
                  src={c.image}
                  alt={c.label}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span
                  className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-white/95 backdrop-blur text-[10px] uppercase tracking-[0.18em] font-extrabold text-[#0e0e10] px-2.5 py-1 rounded-full"
                >
                  <span
                    className="w-2.5 h-2.5 rounded-full border border-black/15"
                    style={{ background: c.swatch }}
                  />
                  {c.label}
                </span>
              </div>
              <div className="p-4 flex items-center justify-between">
                <div>
                  <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-[#8a8a8a]">
                    From
                  </div>
                  <div className="text-[15px] font-extrabold text-[#0e0e10] tabular-nums leading-none mt-0.5">
                    $147
                  </div>
                </div>
                <span className="text-[11px] font-extrabold uppercase tracking-wider text-[#0e0e10] group-hover:underline whitespace-nowrap">
                  Shop →
                </span>
              </div>
            </button>
          ))}
        </div>

        <div className="mt-10 text-center">
          <button
            type="button"
            onClick={() =>
              document.getElementById("shop")?.scrollIntoView({ behavior: "smooth" })
            }
            data-testid="color-showcase-cta"
            className="pill-btn px-8 py-4 text-[14px]"
          >
            Build your bundle — from $147 →
          </button>
          <p className="mt-3 text-[11px] uppercase tracking-[0.18em] font-bold text-[#6b6b72]">
            5 colors · 2 lofts · 100-night trial
          </p>
        </div>
      </div>
    </section>
  );
}
